import { UnitDecorator } from "./UnitModel";
import { BatchDecorator } from "./BatchModel";

export const ProductModel = {
  code: "",
  id: "",
  image: "",
  name: "",
  reference_number: "",
  units: [],
  batches: [],
};

export class ProductDecorator {
  constructor(product) {
    this.product = product;
  }

  formatUnit(units) {
    return units.map((item) => new UnitDecorator(item).toRequest());
  }
  formatBatch(batches) {
    return batches.map((item) => new BatchDecorator(item).toRequest());
  }
  toRequest() {
    return {
      code: this.product.code,
      id: this.product.id,
      image: this.product.image,
      name: this.product.name,
      reference_number: this.product.reference_number,
      units: this.formatUnit(this.product.units),
      batches: this.formatBatch(this.product.batches),
    };
  }
}
